"use strict";
import { customMarker, customArrowMarker } from ".";
import L from "../leaflet";
const nodeMarker = (node) => {
  var _a, _b, _c, _d;
  if (!((_a = node.lonlat) == null ? void 0 : _a.latitude) || !((_b = node.lonlat) == null ? void 0 : _b.longitude)) return null;
  const location = L.latLng(node.lonlat.latitude, node.lonlat.longitude);
  if ((_c = node == null ? void 0 : node.extendedData) == null ? void 0 : _c.componentUrl) {
    if (((_d = node == null ? void 0 : node.extendedData) == null ? void 0 : _d.spacePageHost) === window.location.hostname) {
      return customMarker(location);
    } else {
      return customArrowMarker(location);
    }
  } else {
    return customMarker(location);
  }
};
export default nodeMarker;
